export default function Logo({ markSize = 40, withWordmark = true }) {
  return (
    <span className="flex items-center gap-3">
      <img
        src="/logo-mark.png"
        alt="Preece Refurbishments logo"
        width={markSize}
        height={markSize}
        className="rounded-[4px] shrink-0"
      />
      {withWordmark && (
        <span className="leading-none">
          <span className="block font-serif text-xl text-[#f5f5f0]">Preece</span>
          <span className="block text-[10px] uppercase tracking-[0.3em] text-[#a3a3a3] mt-1">
            Refurbishments
          </span>
        </span>
      )}
    </span>
  );
}
